import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IrisReportResponse, IrisSummaryFiltersDTO } from '../types/iris-report';
import { PaymentsApiRequestService } from './payments.request.service';

@Injectable()
export class IrisService {
  constructor(private request: PaymentsApiRequestService) { }

  getBankSummary(civilId: string, filters?: IrisSummaryFiltersDTO): Observable<IrisReportResponse> {
    const params: Record<string, string> = {};

    if (filters?.dateFrom) {
      params['dateFrom'] = filters.dateFrom;
    }
    if (filters?.dateTo) {
      params['dateTo'] = filters.dateTo;
    }
    if (filters?.description) {
      params['description'] = filters.description;
    }
    if (filters?.amountFrom != null) {
      params['amountFrom'] = String(filters.amountFrom);
    }
    if (filters?.amountTo != null) {
      params['amountTo'] = String(filters.amountTo);
    }

    return this.request.get(['iris', civilId, 'summary'], { params });
  }
}